import { useQuery } from "@tanstack/react-query";
import { BRIEF_PAYMENT_AGGREGATION_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefPaymentAggregation(briefId: string) {
  const { data, isFetching } = useQuery({
    queryKey: [...BRIEF_PAYMENT_AGGREGATION_QUERY_KEY, briefId],
    queryFn: () => BriefService.getBriefPaymentAggregation(briefId),
  });

  return {
    aggregation: data?.data,
    isFetching,
  };
}
